/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Logoalt1Inputs */

const id_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const ms_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const da_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const de_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const en_us2_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const es_es2_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de EGDATA`)
};

const es_mx2_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de EGDATA`)
};

const fil_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo ng EGDATA`)
};

const fr_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const it_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const hu_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA logó`)
};

const nl_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const no_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-logo`)
};

const pl_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const pt_br2_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo do EGDATA`)
};

const pt_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logótipo EGDATA`)
};

const ro_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const fi_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-logo`)
};

const sv_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-logotyp`)
};

const vi_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const tr_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logosu`)
};

const cs_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const bg_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лого на EGDATA`)
};

const ru_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип EGDATA`)
};

const uk_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип EGDATA`)
};

const ar_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شعار EGDATA`)
};

const hi_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA लोगो`)
};

const th_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โลโก้ EGDATA`)
};

const ja_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA ロゴ`)
};

const zh_cn2_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const zh_hant1_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const ko_nav_logoalt1 = /** @type {(inputs: Nav_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA 로고`)
};

/**
* | output |
* | --- |
* | "EGDATA Logo" |
*
* @param {Nav_Logoalt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_logoalt1 = /** @type {((inputs?: Nav_Logoalt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Logoalt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_logoalt1(inputs)
	if (locale === "ms") return ms_nav_logoalt1(inputs)
	if (locale === "da") return da_nav_logoalt1(inputs)
	if (locale === "de") return de_nav_logoalt1(inputs)
	if (locale === "en-US") return en_us2_nav_logoalt1(inputs)
	if (locale === "es-ES") return es_es2_nav_logoalt1(inputs)
	if (locale === "es-MX") return es_mx2_nav_logoalt1(inputs)
	if (locale === "fil") return fil_nav_logoalt1(inputs)
	if (locale === "fr") return fr_nav_logoalt1(inputs)
	if (locale === "it") return it_nav_logoalt1(inputs)
	if (locale === "hu") return hu_nav_logoalt1(inputs)
	if (locale === "nl") return nl_nav_logoalt1(inputs)
	if (locale === "no") return no_nav_logoalt1(inputs)
	if (locale === "pl") return pl_nav_logoalt1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_logoalt1(inputs)
	if (locale === "pt") return pt_nav_logoalt1(inputs)
	if (locale === "ro") return ro_nav_logoalt1(inputs)
	if (locale === "fi") return fi_nav_logoalt1(inputs)
	if (locale === "sv") return sv_nav_logoalt1(inputs)
	if (locale === "vi") return vi_nav_logoalt1(inputs)
	if (locale === "tr") return tr_nav_logoalt1(inputs)
	if (locale === "cs") return cs_nav_logoalt1(inputs)
	if (locale === "bg") return bg_nav_logoalt1(inputs)
	if (locale === "ru") return ru_nav_logoalt1(inputs)
	if (locale === "uk") return uk_nav_logoalt1(inputs)
	if (locale === "ar") return ar_nav_logoalt1(inputs)
	if (locale === "hi") return hi_nav_logoalt1(inputs)
	if (locale === "th") return th_nav_logoalt1(inputs)
	if (locale === "ja") return ja_nav_logoalt1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_logoalt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_logoalt1(inputs)
	return ko_nav_logoalt1(inputs)
});
export { nav_logoalt1 as "nav.logoAlt" }